module.exports = __webpack_public_path__ + "static/media/evento-carioca-anime-site.a133f1e4.jpg";